import { NgModule } from '@angular/core';
import { AssetPathPipe } from './asset-path.pipe';
import { AssetService } from './asset.service';

@NgModule({
  declarations: [AssetPathPipe],
  providers: [AssetService],
  exports: [AssetPathPipe],
})
export class AssetServiceModule {}
